import React, { useEffect, useState } from 'react';
import Header from './Header';
import HeroSection from './HeroSection';
import VideoBanner from './VideoBanner';
import ServicesSection from './ServicesSection';
import ProfileSection from './ProfileSection';
import ProcessSection from './ProcessSection';
import ReferencesSection from './ReferencesSection';
import AboutSection from './AboutSection';
import BeforeAfterSection from './BeforeAfterSection';
import CollaborationSection from './CollaborationSection';
import ContactSection from './ContactSection';
import ModernForm from './ModernForm';
import Footer from './Footer';
import WhatsAppButton from './WhatsAppButton';
import { useLenis } from '../hooks/useLenis';
import { useLanguage } from '../contexts/LanguageContext';
import { getTranslation } from '../translations/translations';

const HomePage = () => {
  const [isLoading, setIsLoading] = useState(true);
  const { language } = useLanguage();
  
  // Activer Lenis smooth scroll
  useLenis();

  useEffect(() => {
    // Simulate loading time
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  if (isLoading) {
    return (
      <div className="min-h-screen bg-black flex items-center justify-center">
        <div className="animate-pulse">
          <div className="w-20 h-20 border-4 border-gray-300 border-t-[#DC1A5F] rounded-full animate-spin"></div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-black">
      <Header />
      <main>
        <section id="accueil">
          <HeroSection />
        </section>
        <ProcessSection />
        {/* La section texte "Découvrez mon processus créatif..." a été supprimée */}
        <VideoBanner />
        <section id="services">
          <ServicesSection />
        </section>
        <section id="references">
          <ReferencesSection />
        </section>
        <section id="about">
          <AboutSection />
        </section>
        <BeforeAfterSection />
        <section id="contact-form" className="py-20 bg-black">
          <div className="container mx-auto px-4">
            <div className="text-center mb-6">
              <h2 className="text-3xl md:text-4xl font-bold mb-4">
                <span className="gradient-text">{getTranslation(language, 'form.intro.title')}</span>
              </h2>
              <p className="text-gray-300 max-w-2xl mx-auto">
                {getTranslation(language, 'form.intro.subtitle')}
              </p>
            </div>
            <ModernForm />
          </div>
        </section>
        <section id="collaboration">
          <CollaborationSection />
        </section>
        <section id="contact">
          <ContactSection />
        </section>
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
};

export default HomePage;